import { ApiService } from '~/shared/api'
import type { SubscribeDto } from '~/types/subscriptions'
import type { AxiosResponse } from 'axios'

export class SubscriptionsService extends ApiService {
  readonly urls = {
    subscriptionUrl: '/api/v1/yavagro/subscriptions/subscribe',
  }

  subscribe(dto: SubscribeDto): Promise<AxiosResponse> {
    return this.http.request({
      data: dto,
      method: 'POST',
      url: this.urls.subscriptionUrl,
      silent: true,
    })
  }
}
